module.exports = __webpack_public_path__ + "img/financial-relation.9393b633.png";